import React, { useState, useRef } from "react";
import axios from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Styles from "../.././styles/vendorDashboard.module.css";
import GlobalButton from "./GlobalButton";

const FileUploader = ({
  initialFiles = [],
  onFilesUpload,
  typeOfFilesAllowed = "images/*",
}) => {
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null); // Use ref to access the input
  const [uploadedFiles, setUploadedFiles] = useState(initialFiles); // For uploaded files (URLs)
  const [loading, setLoading] = useState(false);
  // Handle file selection and add them to state
  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files); // Convert FileList to array
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const [isImageModalOpen, setIsImageModalOpen] = useState(false); // Modal visibility state
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // Current image index
  const [selectedImage, setSelectedImage] = useState(null); // Selected image state

  const openImageModal = (index) => {
    setSelectedImage(uploadedFiles[index]); // Set the selected image
    setCurrentImageIndex(index); // Set the current image index
    setIsImageModalOpen(true); // Open the modal
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false); // Close the modal
    setSelectedImage(null); // Clear selected image
  };

  const handleNextImage = () => {
    const nextIndex = (currentImageIndex + 1) % uploadedFiles.length; // Loop back to the first image if at the end
    setCurrentImageIndex(nextIndex);
    setSelectedImage(uploadedFiles[nextIndex]);
  };

  const handlePrevImage = () => {
    const prevIndex =
      (currentImageIndex - 1 + uploadedFiles.length) % uploadedFiles.length; // Loop back to the last image if at the beginning
    setCurrentImageIndex(prevIndex);
    setSelectedImage(uploadedFiles[prevIndex]);
  };

  // Handle file deletion
  const handleDelete = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);

    // Clear the file input field if all files are deleted
    if (updatedFiles.length === 0 && fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  // Handle uploaded file deletion (for existing uploaded files)
  const handleDeleteUploaded = (index) => {
    const updatedUploadedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedUploadedFiles);

    onFilesUpload(updatedUploadedFiles); // Notify parent of changes
  };

  // Handle form submission or upload logic (stubbed)
  const handleUpload = async () => {
    if (files?.length > 0) {
      const formDataNew = new FormData();
      // Loop through each file and append it separately to FormData
      files.forEach((file) => {
        formDataNew.append("files", file); // Append each file individually
      });
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          formDataNew,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.data.success) {
          const uploadedUrls = response.data.data;
          setUploadedFiles((prev) => [...prev, ...uploadedUrls]);
          onFilesUpload([...uploadedFiles, ...uploadedUrls]); // Notify parent with updated file URLs
          setFiles([]); // Clear new files

          // Clear file input
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
        }
      } catch (err) {
        console.error("Error uploading file", err);
      } finally {
        setLoading(false); // Set loading to false once the upload is complete
      }
    }
    // Here you can call an API or perform the upload to S3 or another server
  };

  return (
    <div className="file-uploader">
      <input
        ref={fileInputRef} // Set the ref to access the input
        type="file"
        multiple
        accept={typeOfFilesAllowed}
        onChange={handleFileChange}
        className="my-2 p-2"
      />

      {files.length > 0 && (
        <div className="file-list">
          <h3>New Files:</h3>
          <ul
            className={`flex flex-col sm:flex-row gap-2 flex-wrap whitespace-nowrap max-h-[150px] overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
          >
            {files.map((file, index) => (
              <li
                key={index}
                className="border p-3 my-2 flex items-center flex-col gap-2"
                // onClick={() => openImageModal(index)}
              >
                {/* Check if the file is an image, video, or PDF */}
                {file.type.startsWith("image/") ? (
                  <img
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    className="h-20 w-20 object-cover rounded"
                  />
                ) : file.type.startsWith("video/") ? (
                  <video
                    controls
                    className="h-20 w-20 object-cover rounded"
                    src={URL.createObjectURL(file)}
                  />
                ) : file.type === "application/pdf" ? (
                  <embed
                    src={URL.createObjectURL(file)}
                    type="application/pdf"
                    className="h-20 w-20 object-cover rounded"
                    title={file.name}
                  />
                ) : null}

                <GlobalButton
                  variant="warning"
                  size="small"
                  onClick={() => handleDelete(index)}
                >
                  {`Delete`}
                </GlobalButton>
              </li>
            ))}
          </ul>
          <div style={{ width: "200px" }}>
            <GlobalButton
              variant="primary"
              size="small"
              isLoading={loading}
              onClick={handleUpload}
            >
              {`Upload All Files`}
            </GlobalButton>
          </div>
        </div>
      )}

      {isImageModalOpen && selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 transition-opacity duration-300">
          <button
            className="absolute top-[1.75rem] right-[13.75rem] text-white bg-black bg-opacity-70 p-2 rounded-full hover:bg-opacity-90 transition duration-200"
            onClick={closeImageModal}
          >
            <CancelIcon />
          </button>
          <div className="relative p-4 rounded-lg w-[90%] h-[90%] md:w-[70%] md:h-[70%]  flex flex-col items-center justify-center overflow-hidden">
            {/* <button
              className="absolute top-3 right-[0.75rem] text-white bg-black bg-opacity-70 p-2 rounded-full hover:bg-opacity-90 transition duration-200"
              onClick={closeImageModal}
            >
              <CancelIcon />
            </button> */}
            <div className="flex justify-between items-center w-full h-full">
              <button
                className="bg-gray-600 text-white p-3 rounded-full shadow-md hover:bg-gray-700 hover:scale-110 transition-transform duration-200"
                onClick={handlePrevImage}
              >
                <ArrowBackIosNewIcon />
              </button>
              <div className="flex-grow flex justify-center items-center h-full">
                <img
                  src={
                    selectedImage instanceof File
                      ? URL.createObjectURL(selectedImage)
                      : selectedImage
                  }
                  alt={`image-${currentImageIndex}`}
                  className="max-w-full max-h-full object-contain rounded-md border border-gray-300 shadow-sm"
                />
              </div>
              <button
                className="bg-gray-600 text-white p-3 rounded-full shadow-md hover:bg-gray-700 hover:scale-110 transition-transform duration-200"
                onClick={handleNextImage}
              >
                <ArrowForwardIosIcon />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Display already uploaded files */}
      {uploadedFiles.length > 0 && (
        <div className="uploaded-file-list pl-2">
          <h3>Uploaded Files:</h3>
          <ul
            className={`flex flex-col sm:flex-row gap-2 flex-wrap max-h-[160px] overflow-x-hidden ${Styles["custom1-scrollbar"]}`}
          >
            {uploadedFiles.map((fileUrl, index) => (
              <li
                key={index}
                className="border p-3 my-2 flex items-center flex-col gap-2 cursor-pointer"
              >
                {/* Check if the uploaded file is an image, video, or PDF */}
                {fileUrl.endsWith(".mp4") || fileUrl.endsWith(".mov") ? (
                  <video
                    controls
                    className="h-20 w-20 object-cover rounded"
                    src={fileUrl}
                  />
                ) : fileUrl.endsWith(".pdf") ? (
                  <embed
                    src={fileUrl}
                    type="application/pdf"
                    className="h-20 w-20 object-cover rounded"
                    title={`uploaded-${index}`}
                  />
                ) : (
                  <img
                    src={fileUrl}
                    alt={`uploaded-${index}`}
                    className="h-20 w-20 object-cover rounded"
                    onClick={() => openImageModal(index)}
                  />
                )}

                <GlobalButton
                  type="button"
                  variant="warning"
                  size="small"
                  onClick={() => handleDeleteUploaded(index)}
                >
                  {`Delete`}
                </GlobalButton>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FileUploader;
